import { GET_ERRORS, SHOW_BOOKS } from "./types";
import axios from "axios";

//export const SERVER_ADDR = 'https://gutendex.com';
export const SERVER_ADDR = 'http://skunkworks.ignitesol.com:8000';

export const getFictionBooks = () => dispatch => {
  axios
    .get(
      `${SERVER_ADDR}/books/?topic=fiction&mime_type=image/jpeg`
    )
    .then(res => {
      dispatch({
        type: SHOW_BOOKS,
        payload: res.data
      });
    })
    .catch(err => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data.message
      });
    });
};
export const getdramaBooks = () => dispatch => {
  axios
    .get(
      `${SERVER_ADDR}/books/?topic=drama&mime_type=image/jpeg`
    )
    .then(res => {
      dispatch({
        type: SHOW_BOOKS,
        payload: res.data
      });
    })
    .catch(err => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data.message
      });
    });
};
export const gethumorBooks = () => dispatch => {
  axios
    .get(
      `${SERVER_ADDR}/books/?topic=humor&mime_type=image/jpeg`
    )
    .then(res => {
      dispatch({
        type: SHOW_BOOKS,
        payload: res.data
      });
    })
    .catch(err => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data.message
      });
    });
};
export const getpolitcsBooks = () => dispatch => {
  axios
    .get(
      `${SERVER_ADDR}/books/?topic=politics&mime_type=image/jpeg`
    )
    .then(res => {
      dispatch({
        type: SHOW_BOOKS,
        payload: res.data
      });
    })
    .catch(err => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data.message
      });
    });
};
export const getHistoryBooks = () => dispatch => {
  axios
    .get(
      `${SERVER_ADDR}/books/?topic=history&mime_type=image/jpeg`
    )
    .then(res => {
      dispatch({
        type: SHOW_BOOKS,
        payload: res.data
      });
    })
    .catch(err => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data.message
      });
    });
};
export const getPhilosophyBooks = () => dispatch => {
  axios
    .get(
      `${SERVER_ADDR}/books/?topic=philosophy&mime_type=image/jpeg`
    )
    .then(res => {
      dispatch({
        type: SHOW_BOOKS,
        payload: res.data
      });
    })
    .catch(err => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data.message
      });
    });
};
export const getAdventuresBooks = () => dispatch => {
  axios
    .get(
      `${SERVER_ADDR}/books/?topic=adventures&mime_type=image/jpeg`
    )
    .then(res => {
      dispatch({
        type: SHOW_BOOKS,
        payload: res.data
      });
    })
    .catch(err => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data.message
      });
    });
};
export const getallBooks = () => dispatch => {
  axios
    .get(`${SERVER_ADDR}/books/`)
    .then(res => {
      dispatch({
        type: SHOW_BOOKS,
        payload: res.data
      });
    })
    .catch(err => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data.message
      });
    });
};
